import React from 'react';
import { IonIcon } from '@ionic/react';
import { useDispatch } from 'react-redux';
import {
  ViewMode,
  setViewMode
} from 'features/shared/documents/DocumentsSlice';
import Grid from 'assets/icons/grid.svg';
import List from 'assets/icons/list.svg';

interface ViewModeToggleProps {
  currentViewMode: ViewMode;
  itemCount: number;
}

const ViewModeToggle: React.FC<ViewModeToggleProps> = ({
  currentViewMode,
  itemCount
}) => {
  const dispatch = useDispatch();

  return (
    <div id="hk-digital-document-list-toggles">
      <span className="hk-digital-document-list-toggles-item-count">
        {itemCount} Items
      </span>
      <IonIcon
        icon={List}
        className={currentViewMode === ViewMode.LIST ? 'active' : ''}
        onClick={() => dispatch(setViewMode(ViewMode.LIST))}
      />
      <IonIcon
        icon={Grid}
        className={currentViewMode === ViewMode.GRID ? 'active' : ''}
        onClick={() => dispatch(setViewMode(ViewMode.GRID))}
      />
    </div>
  );
};

export default ViewModeToggle;
